/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Notfound1Inputs */

const id_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item tidak ditemukan`)
};

const ms_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item tidak ditemui`)
};

const da_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item ikke fundet`)
};

const de_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item nicht gefunden`)
};

const en_us2_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item not found`)
};

const es_es2_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítem no encontrado`)
};

const es_mx2_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítem no encontrado`)
};

const fil_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi nahanap ang item`)
};

const fr_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item non trouvé`)
};

const it_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articolo non trovato`)
};

const hu_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elem nem található`)
};

const nl_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item niet gevonden`)
};

const no_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element ikke funnet`)
};

const pl_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element nie znaleziony`)
};

const pt_br2_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item não encontrado`)
};

const pt_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item não encontrado`)
};

const ro_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Element negăsit`)
};

const fi_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohdetta ei löydy`)
};

const sv_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objektet hittades inte`)
};

const vi_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy mục`)
};

const tr_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğe bulunamadı`)
};

const cs_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položka nenalezena`)
};

const bg_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обектът не е намерен`)
};

const ru_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объект не найден`)
};

const uk_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елемент не знайдено`)
};

const ar_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العنصر غير موجود`)
};

const hi_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम नहीं मिला`)
};

const th_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบรายการ`)
};

const ja_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテムが見つかりません`)
};

const zh_cn2_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品未找到`)
};

const zh_hant1_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品未找到`)
};

const ko_items_notfound1 = /** @type {(inputs: Items_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이템을 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "Item not found" |
*
* @param {Items_Notfound1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_notfound1 = /** @type {((inputs?: Items_Notfound1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Notfound1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_notfound1(inputs)
	if (locale === "ms") return ms_items_notfound1(inputs)
	if (locale === "da") return da_items_notfound1(inputs)
	if (locale === "de") return de_items_notfound1(inputs)
	if (locale === "en-US") return en_us2_items_notfound1(inputs)
	if (locale === "es-ES") return es_es2_items_notfound1(inputs)
	if (locale === "es-MX") return es_mx2_items_notfound1(inputs)
	if (locale === "fil") return fil_items_notfound1(inputs)
	if (locale === "fr") return fr_items_notfound1(inputs)
	if (locale === "it") return it_items_notfound1(inputs)
	if (locale === "hu") return hu_items_notfound1(inputs)
	if (locale === "nl") return nl_items_notfound1(inputs)
	if (locale === "no") return no_items_notfound1(inputs)
	if (locale === "pl") return pl_items_notfound1(inputs)
	if (locale === "pt-BR") return pt_br2_items_notfound1(inputs)
	if (locale === "pt") return pt_items_notfound1(inputs)
	if (locale === "ro") return ro_items_notfound1(inputs)
	if (locale === "fi") return fi_items_notfound1(inputs)
	if (locale === "sv") return sv_items_notfound1(inputs)
	if (locale === "vi") return vi_items_notfound1(inputs)
	if (locale === "tr") return tr_items_notfound1(inputs)
	if (locale === "cs") return cs_items_notfound1(inputs)
	if (locale === "bg") return bg_items_notfound1(inputs)
	if (locale === "ru") return ru_items_notfound1(inputs)
	if (locale === "uk") return uk_items_notfound1(inputs)
	if (locale === "ar") return ar_items_notfound1(inputs)
	if (locale === "hi") return hi_items_notfound1(inputs)
	if (locale === "th") return th_items_notfound1(inputs)
	if (locale === "ja") return ja_items_notfound1(inputs)
	if (locale === "zh-CN") return zh_cn2_items_notfound1(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_notfound1(inputs)
	return ko_items_notfound1(inputs)
});
export { items_notfound1 as "items.notFound" }